import React from 'react';
import Divider from "@material-ui/core/Divider";
import {Field, Formik} from "formik";
import TextField from "../../../components/Ui/TextField";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import {UPDATE_USER_INFOS} from "../../../api/Api";
import axios from 'axios';
import * as Yup from 'yup'
import {useDispatch, useSelector, useStore} from "react-redux";
import {actions as authActions} from "../../../modules/Auth/_redux/authRedux";
import {toast} from 'react-toastify';

export default function UserInfoUpdatePage(props){

    const {user} = useSelector(state => state.auth);
    const dispatcher = useDispatch()


    async function updateInfos(values,formikHelpers){

        try {

            const response = await axios.patch(UPDATE_USER_INFOS,values);

            dispatcher(authActions.fulfillUser(response.data))


            toast.success("Modification enregistré avec succès", {
                position: toast.POSITION.BOTTOM_LEFT,
                autoClose: 5000
            });

            console.log(response);

        } catch (e) {
            console.log(e);
        } finally {
            formikHelpers.setSubmitting(false)
        }


    }

    return (
        <div className={''}>

            <div className={'text-right'}>
                <div className={'d-inline-block text-left'}>

                    <div className="h3 text-primary font-weight-bold">
                        Informations personnelles
                    </div>
                    <div className={'small'}>
                        Modification de vos Informations personnelles
                    </div>
                </div>
                <Divider />

            </div>

            <div>

                <Formik
                    validationSchema={Yup.object().shape({
                        phone: Yup.string().required('Champs obligatoire')
                            .matches(/[0-9]{10}/,'Vou devez saisir un numéro de téléphone valide')
                    })}
                    initialValues={{
                        phone: user.phone,
                    }}
                    onSubmit={updateInfos}
                >

                    {
                        (formikHelpers) => {

                            return (
                                <div className={'row'}>

                                    <div className="col-12 my-3">

                                        <Field
                                            component={TextField}
                                            label={'Numéro de téléphone'}
                                            name={'phone'}
                                        />

                                    </div>


                                    <div className="col-12 mx-3 text-right mt-lg-20">

                                        <BootstrapLoadingButton onClick={formikHelpers.submitForm} isLoading={formikHelpers.isSubmitting} className={'d-inline-block btn btn-light-primary'}>
                                            Modifiez vos informations
                                        </BootstrapLoadingButton>

                                    </div>

                                </div>
                            );

                        }
                    }

                </Formik>

            </div>

        </div>
    );
}